import React from "react";
import { motion } from "framer-motion";

const Achievement = () => {
  const metrics = [
    {
      value: "30%",
      label: "Cost Saving",
      color: "bg-[#3B82F6]",
      height: "h-28 sm:h-36 md:h-44",
    },
    {
      value: "75%",
      label: "Success Rate",
      color: "bg-[#6EE7B7]",
      height: "h-40 sm:h-56 md:h-64",
    },
    {
      value: "10k+",
      label: "Deploy Rate",
      color: "bg-[#FDE047]",
      height: "h-52 sm:h-72 md:h-80",
    },
  ];

  return (
    <motion.div
      className="bg-[#1A0B05] py-4 sm:py-6 md:py-8 lg:py-10 xl:py-12 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      <div className="max-w-screen-2xl mx-auto bg-[#2A1208]/50 rounded-3xl sm:rounded-[40px] p-6 sm:p-8 md:p-10 border border-white/5 relative overflow-hidden">
        {/* Subtle Grid Background */}
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        ></div>

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 items-center">
          {/* Left Content */}
          <div className="max-w-xl text-center lg:text-left">
            <motion.h2
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-1 sm:mb-2 md:mb-3 lg:mb-4 xl:mb-5"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
            >
              Achieve Tangible Outcomes with Supply Chain AI
            </motion.h2>
            <motion.p
              className="text-gray-400 text-base sm:text-lg mb-8 sm:mb-10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.25 }}
            >
              Discover how Optivus can help you drive innovation,
            </motion.p>
            <motion.button
              className="bg-brandOrange text-white px-8 sm:px-10 py-3 sm:py-4 rounded-xl font-medium hover:bg-[#d44610] transition-colors"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              Contact Us
            </motion.button>
          </div>

          {/* Right Content - Visual Bars */}
          <div className="flex items-end justify-center lg:justify-end gap-6 lg:gap-12">
            {metrics.map((item, index) => (
              <motion.div
                key={index}
                className={`${item.color} ${item.height} w-20 sm:w-24 md:w-32 rounded-2xl sm:rounded-3xl p-4 sm:p-6 flex flex-col items-center justify-end relative shadow-lg transition-transform hover:scale-105`}
                initial={{ scaleY: 0, opacity: 0 }}
                whileInView={{ scaleY: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{
                  duration: 1.1,
                  delay: 0.3 + index * 0.18,
                  ease: [0.16, 1, 0.3, 1],
                }}
                style={{ originY: 1 }} // grow from bottom
              >
                {/* Pill element at the top */}
                <div className="absolute top-3 sm:top-4 w-10 sm:w-12 h-2 bg-[#0C1A14]/40 rounded-full"></div>

                <div className="text-center">
                  <motion.span
                    className="block text-xl sm:text-2xl md:text-3xl font-bold text-[#0C1A14]"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.9 + index * 0.18 }}
                  >
                    {item.value}
                  </motion.span>
                  <motion.span
                    className="block text-[10px] sm:text-xs font-medium text-[#0C1A14] opacity-70 mt-1 whitespace-nowrap"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 0.7 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 1.1 + index * 0.18 }}
                  >
                    {item.label}
                  </motion.span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
